import React from 'react';
import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalFooter,
	ModalBody,
	Button,
	Text,
	VStack,
	Icon,
	useColorModeValue,
} from '@chakra-ui/react';
import { MdPhoneInTalk, MdCallEnd, MdVideoCall } from 'react-icons/md';

export const IncomingCallModal = ({ isOpen, callData, onAccept, onDecline }) => {
	const bg = useColorModeValue('white', 'gray.800');

	if (!callData) return null;

	const { imei, patientId } = callData;

	return (
		<Modal
			isOpen={isOpen}
			onClose={onDecline}
			isCentered
			closeOnOverlayClick={false}
			closeOnEsc={false}
			size="sm"
		>
			<ModalOverlay backdropFilter="blur(5px)" />
			<ModalContent bg={bg} borderTop="4px solid #38B2AC">
				<ModalHeader textAlign="center">
					<VStack>
						<Icon as={MdVideoCall} w={10} h={10} color="teal.500" />
						<Text>Llamada Entrante</Text>
					</VStack>
				</ModalHeader>
				<ModalBody textAlign="center">
					<Text fontSize="lg" fontWeight="bold" mb={2}>
						Dispositivo: {imei}
					</Text>
					{patientId && <Text color="gray.500">Paciente ID: {patientId}</Text>}
					<Text mt={4}>¿Desea aceptar la videollamada?</Text>
				</ModalBody>

				<ModalFooter justifyContent="center" gap={4}>
					<Button
						colorScheme="red"
						onClick={onDecline}
						leftIcon={<Icon as={MdCallEnd} />}
						variant="outline"
					>
						Rechazar
					</Button>
					<Button
						colorScheme="teal"
						onClick={onAccept}
						leftIcon={<Icon as={MdPhoneInTalk} />}
						boxShadow="lg"
						_hover={{ transform: 'scale(1.05)' }}
					>
						Contestar
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};